export const patientsLookup = {
  tabs: {
    patientLookup: 'Patient Lookup',
    globalLookup: 'Global Lookup'
  },
  form: {
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    dateOfBirth: 'Date of Birth',
    lookup: 'Lookup',
    instructions:
      'Lookup Patients by First Name, Last Name or Date of Birth, or Phone Number or their combinations. You may enter first few letters for first and last names (in either lowercase or uppercase). Full phone numbers must be entered for the searches.'
  },
  patientsGrid: {
    starred: 'Starred',
    patientName: 'Patient Name',
    dob: 'DOB',
    phoneNumber: 'Phone Number',
    programs: 'Programs'
  },
  globalLookupGrid: {
    servicesGroup: 'Services',
    patientName: 'Patient Name',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    zipcode: 'Zipcode',
    action: 'Action',
    switchAccountTooltip: 'Switch Patient to Another RPM-Enabled Pharmacy'
  },
  programCell: {
    rpm: 'RPM',
    mtm: 'MTM',
    tcm: 'TCM',
    sameOrgTooltip: 'This service is being provided to this patient by another organization. Please contact support for more details.',
    unavailableTooltip: 'Please contact support to have your organization provide this service to this patient.'
  },
  tagCell: {
    tooltip: 'Tag Patient'
  },
  dialogs: {
    serviceUnavailableTitle: 'Service unavailable',
    serviceUnavailableMessage: 'Please contact Truentity Health if you wish to offer this service to this patient.',
    updateProfileTitle: 'Update Profile for the Onboarded Patient',
    updateProfileSubHeader: `
    Please note that a Client Org and a Location must be assigned.
    Additionally, if the full address is available for this patient, we highly recommend that it be properly entered for reliable access to their healthcare data.
  `,
    skipWarningTitle: 'Warning',
    skipWarningMessage:
      "Note that the patient was onboarded without a Client Org or a Location assigned. We highly recommend that these be assigned from the Patient's Profile section.",
    onboardedTitle: 'Patient Onboarded',
    onboardPatientTitle: 'Onboard Patient',
    onboardConfirmMessage: (serviceName: string) =>
      `Are you sure you want to onboard this patient for the ${serviceName} offered by your organization`,
    onboardInfoDescription: (fullName: string, serviceLabel: string) =>
      `${fullName} is about to be onboarded for the ${serviceLabel} Service. This patient's existing profile information will be used. <br><br><strong>Please proceed to update any missing or additional profile information  needed for the ${serviceLabel} Service.</strong></br></br>`,
    transferAffiliationTitle: (patientFullName: string) => `Transfer ${patientFullName}'s affiliation to a different Organization`
  },
  snackbars: {
    fetchPatientLookupFailed: 'Unable to retrieve patient lookup results',
    fetchGlobalLookupFailed: 'Unable to retrieve global lookup results',
    fetchPatientLookupCountFailed: 'Unable to retrieve patient lookup count',
    fetchGlobalLookupCountFailed: 'Unable to retrieve global lookup count',
    lookupValidationRequired: 'One of the First Name, Last Name, Phone Number and Date of Birth is required',
    reloadPatientsFailed: 'Unable to reload patients',
    fetchPatientDetailFailed: 'Unable to retrieve all of the customer data',
    onboardSuccess: 'Successfully onboarded the patient',
    onboardFailed: 'Failed to onboard the patient'
  }
} as const;
